import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";


const OteFpaForm = ({ type, initialValues, onSubmit }: OteFpaFormProps) => {
    const { t } = useTranslation();

    const validationSchema= Yup.object({
      description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          if (type === "create") {
            onSubmit(values, formikHelpers);
          } else {
            onSubmit(
              values, formikHelpers
            );
          }
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Όνομα Κατηγορίας ΦΠΑ")}*`}
                  </label>
                  <Field
                    name="description"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="description"
                   
                  />
                  <div className="text-danger">
                    {errors.description && touched.description && (
                      <div>{errors.description}</div>
                    )}
                  </div>
                </Col>
            
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default OteFpaForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: IPostNewOteFpa;
      onSubmit: (
        values: IPostNewOteFpa,
        formikHelpers: FormikHelpers<IPostNewOteFpa>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IPostEditOteFpa;
      onSubmit: (
        values: IPostEditOteFpa,
        formikHelpers: FormikHelpers<IPostEditOteFpa>
      ) => void;
    };

type OteFpaFormProps = CreateOrEdit;